import gql from 'graphql-tag';

export default gql`
  mutation adminUpdateProgramStatus($input: AdminProgramStatusInput!) {
    adminUpdateProgramStatus(input: $input)
  }
`;
